// Şirket bağlam anahtarı (SEM-6041) — kenar çubuğunun marka başlığının altında.
//
// TEK ŞİRKETLİ KİRACIDA HİÇ RENDER EDİLMEZ. Tek seçenekli bir seçici, ne
// olduğu sorulmayan bir soruyu her ekranın tepesine yapıştırır; çok-şirketli
// holding bir özellik, tek şirketli kiracı ise varsayılan durumdur.
//
// Yerli <select>: seçenek kümesi kiracının şirket listesi kadar, yani kısa ve
// düz. Özel bir menü burada yalnız klavye ve ekran okuyucu davranışını elle
// yeniden yazmak olurdu.
//
// "Tüm şirketler" boş dize ile temsil edilir çünkü <option value={null}>
// diye bir şey yok — DOM her değeri dizeye çevirir. Dönüşüm tek yerde,
// onChange'de yapılır.

import { useTranslation } from "react-i18next";

import { useCompanyAxis, useSetActiveCompany } from "@/api/use-company-context";
import { cn } from "@/lib/utils";

const ALL_COMPANIES = "";

export function CompanySwitcher(): React.ReactElement | null {
  const { t } = useTranslation();
  const { companies, active_legal_entity_id: activeId } = useCompanyAxis();
  const setActiveCompany = useSetActiveCompany();

  if (companies.length < 2) return null;

  return (
    <div className="px-3 pb-3">
      <label
        htmlFor="nai-company-switcher"
        className="mb-1 block font-sans text-[11px] font-medium text-[var(--fg-muted)]"
      >
        {t("nav.company_label")}
      </label>
      <select
        id="nai-company-switcher"
        value={activeId ?? ALL_COMPANIES}
        onChange={(event): void => {
          const next = event.target.value;
          setActiveCompany(next === ALL_COMPANIES ? null : next);
        }}
        className={cn(
          "w-full rounded-[8px] border border-[var(--border-default)] bg-[var(--bg-raised)] px-2.5 py-1.5",
          "font-sans text-[13px] text-[var(--fg-primary)]",
          "focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus-ring)]",
        )}
      >
        <option value={ALL_COMPANIES}>{t("nav.company_all")}</option>
        {companies.map((company) => (
          <option key={company.legal_entity_id} value={company.legal_entity_id}>
            {company.name}
          </option>
        ))}
      </select>
    </div>
  );
}
